module.exports = __webpack_public_path__ + "2c98d905c76b14908e839cf782a06f55.svg";